import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';

// 配置dayjs
dayjs.extend(relativeTime); // 启用相对时间插件
dayjs.locale('zh-cn'); // 设置中文语言包

// 添加全局配置
dayjs.defaultFormat = 'YYYY-MM-DD HH:mm:ss';

// 创建Vue插件对象
const dayjsPlugin = {
  install: (app) => {
    // 将dayjs挂载到Vue全局属性
    app.config.globalProperties.$dayjs = dayjs;
    // 提供给组合式API使用
    app.provide('dayjs', dayjs);
  }
};

// 同时导出dayjs函数和Vue插件
export { dayjs };
export default dayjsPlugin;